<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (counter()) {
    <div class="slide-down-modal auto-logout-modal active">
        <div class="alert alert-warning" role="alert">
            <strong>You will be logout after {{ counter() }} seconds.</strong>
        </div>
    </div>
}
